import styled from "@emotion/styled";
import { formInputTheme, TextInputRootBoxProps } from "./formInputTheme";

type StyledContentBeforeContainerProps = Pick<TextInputRootBoxProps, "themeMode" | "validationState">;

// not using sizing constant due to the 2px border (would be 12/sizes.small)
export const StyledContentBeforeContainer = styled("div")<StyledContentBeforeContainerProps>`
    padding-left: ${getPadding};
    display: flex;
`;

function getPadding({ themeMode, validationState }: StyledContentBeforeContainerProps) {
    if (validationState === "error") {
        return formInputTheme.padding.left.error(themeMode);
    } else {
        return formInputTheme.padding.left.rest(themeMode);
    }
}
